import React from 'react';
import styles from './styles.module.scss';
import { Image } from './components/Image';
import { LargeImage } from './components/LargeImage'; 
import { Text } from './components/Text';
import { Card } from './components/Card';

export const ModalIntro = ({ children }) => (
  <div className={styles.modalIntro}>
    {children}
  </div>
);

ModalIntro.Image = Image;
ModalIntro.LargeImage = LargeImage;
ModalIntro.Text = Text;
ModalIntro.Card = Card;
